import * as React from "react";

// style, design
import CancelOtherContractForm from "../../components/Forms/OtherContract/CancelForm/FlowForm";

export default () => {
  return <CancelOtherContractForm />;
};
